export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6699.66c47f39.jpg";